// Constants
import { NEGATIVE_CONSTITUENTS_COLOR, POSITIVE_CONSTITUENTS_COLOR, } from 'SecuritiesApp/ts/constants/attribution.constants';
// Utils
import { formatChange } from 'NewAngular/utils/string-utils';
/**
 * reformats each constituents changes so positive and 0 values have leading '+'.
 */
const formatChanges = (constituents) => {
    const contributorsDetractorsWithReformattedChanges = [];
    for (let i = 0; i < constituents.length; i += 1) {
        const constituent = Object.assign(constituents[i]);
        constituent.change_percent = formatChange(constituent.change_percent);
        constituent.change = formatChange(constituent.change);
        contributorsDetractorsWithReformattedChanges.push(constituent);
    }
    return contributorsDetractorsWithReformattedChanges;
};
/**
 * Assigns the color gradient to each constituent. If the `contribution_points` is the same as the previous
 * constituent, the same color is used.
 */
export const getContributorsDetractorsColorGradient = (constituents, isContributor) => {
    const colors = isContributor ? POSITIVE_CONSTITUENTS_COLOR : NEGATIVE_CONSTITUENTS_COLOR;
    let colorIndex = 0;
    const contributorsDetractorsWithColorGradient = [];
    for (let i = 0; i < constituents.length; i += 1) {
        // Create the color attribute for each constituent
        const constituent = Object.assign(constituents[i], { color: '' });
        if (constituents[i - 1] && constituents[i].contribution_points === constituents[i - 1].contribution_points) {
            constituent.color = contributorsDetractorsWithColorGradient[i - 1].color;
        }
        else {
            constituent.color = colors[colorIndex] ? colors[colorIndex] : 'bg-neutral';
            colorIndex += 1;
        }
        contributorsDetractorsWithColorGradient.push(constituent);
    }
    return formatChanges(contributorsDetractorsWithColorGradient);
};
